module.exports = __webpack_public_path__ + "media/images/arrow-down-black-db5ec7fb041b24894bee4f338a85e093.svg";